import React, { useState, useEffect, useMemo, useRef } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Snackbar,
  Alert,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import { logEventos } from "../../services/services";
import { getData } from "../../services/library";
import { grey } from "@mui/material/colors";

function Dialog_cancelar_envio(props) {
  const [abrirDialogTrEnvi, setAbrirDialogTrEnvi] = useState(
    props.abrirDialogTrEnvi
  );
  const [transferRow, setTransferRow] = useState(props.transferRow);
  const [inventarioTrSumaCan, setInventarioTrSumaCan] = useState([]);
  const [inventarioPrendas, setInventarioPrendas] = useState();
  const [talles, setTalles] = useState([]);
  const [stockPorTalles, setStockPorTalles] = useState([]);
  const [errorCantidad, setErrorCantidad] = useState(false);
  //funcion para obtener sucursales
  const obtenerInventarioTrSumaCan = () => {
    fetch(
      UrlApi +
        "/stock_inventarios/xalmart/" +
        transferRow.almacen_origen +
        "/" +
        transferRow.id_articulo
    )
      .then((data) => data.json())
      .then((data) => setInventarioTrSumaCan(data));
  };

  useEffect(() => {
    obtenerInventarioTrSumaCan();
  }, [transferRow.almacen_origen, transferRow.cantidad_Enviada]);

  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [cantidadInventarioTrSumaCan, setCantidadInventarioTrSumaCan] =
    useState(0);

  // CALCULO DEL TOTAL FINAL
  useEffect(() => {
    setCantidadInventarioTrSumaCan(
      (inventarioTrSumaCan[0]
        ? inventarioTrSumaCan[0].cantidad
        : "no disponible") + transferRow.cantidad_enviada
    );
  }, [inventarioTrSumaCan]);

  const guardarConfirmacionCancelacion = async (e) => {
    logEventos(
      "Guardar confirmación de cancelación",
      "Stock Sucursales",
      "Se guardo cancelación",
      localStorage.getItem("user")
    );
    e.preventDefault();
    await fetch(UrlApi + "/stock_transacciones/" + transferRow.id_transaccion, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        en_transito: 0,
        usuario: localStorage.getItem("user"),
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La cancelación se guardó exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la cancelación");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    // sumar cantidad
    await fetch(
      UrlApi +
        "/stock_inventarios/" +
        transferRow.almacen_origen +
        "/" +
        transferRow.id_articulo,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          cantidad: cantidadInventarioTrSumaCan,
          usuario: localStorage.getItem("user"),
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El artículo se guardó exitosamente !");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el artículo");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

      // inventario por talles
      e.preventDefault();
      if (transferRow.tiene_talles === 1) {
        for (let i = 0; i < stockPorTalles.length; i++) {
          const element = stockPorTalles[i];
          if (element.stock > 0) {
            // Verifica si el talle ya existe en inventarioPrendas
            const talleExistente = inventarioPrendas.find(
              (item) => item.talle === element.id
            );
  
            // Configuración de la solicitud
            const url = talleExistente
              ? `${UrlApi}/stock_prendas/${talleExistente.id}` // PUT si existe
              : `${UrlApi}/stock_prendas`; // POST si no existe
            const metodo = talleExistente ? "PUT" : "POST";
  
            // Calcular la cantidad para el PUT
            const nuevaCantidad = talleExistente
              ? talleExistente.cantidad + element.stock // Suma la cantidad existente con la nueva
              : element.stock;
  
            // Realiza la solicitud
            try {
              const response = await fetch(url, {
                method: metodo,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  almacen: transferRow.almacen_origen,
                  articulo: transferRow.id_articulo,
                  talle: element.id,
                  cantidad: nuevaCantidad, // En el PUT, es la suma
                  usuario: localStorage.getItem("user"),
                }),
              });
  
              if (response.ok) {
                setOpenSnack(true);
                setColorMensaje("#D4EFDF");
                setMensaje(
                  talleExistente
                    ? "El artículo se actualizó exitosamente!"
                    : "El artículo se guardó exitosamente!"
                );
              } else {
                throw new Error("Error al guardar el artículo");
              }
            } catch (error) {
              console.error(error.message);
              setOpenSnack(false);
              setColorMensaje("#F1948A");
              setMensaje("Error al guardar el artículo");
            }
          }
        }
      }


    handleClose();
  };

  const handleClose = () => {
    setAbrirDialogTrEnvi(!abrirDialogTrEnvi);
    if (props.onClose) {
      props.onClose();
    }
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
// console.log("row", transferRow);

   //  TALLES
    const obtenerTalles = () => {
      getData(
        "/stock_prendas_talles/tallesxprendaactivo/" + transferRow.tipo_prenda,
        setTalles
      );
    };
    useEffect(() => {
      if (transferRow.tiene_talles === 1) {
        obtenerTalles();
      }
    }, [transferRow]);
    // console.log("talles", talles);
  
    useEffect(() => {
      // Inicializar stockPorTalles basado en los talles
      const initialStock = talles.map((talle) => ({ id: talle.id, stock: 0 }));
      setStockPorTalles(initialStock);
    }, [talles]); // Se ejecutará cada vez que `talles` cambie
  
    const handleStockChange = (id, newStock) => {
      const stockValue = Number(newStock);
  
      // Evitar valores inválidos
      if (isNaN(stockValue) || stockValue < 0) {
        return;
      }
  
      // Calcula la suma actual de los valores (excluyendo el que se está actualizando)
      const currentTotal = stockPorTalles.reduce((sum, item) => {
        return item.id === id ? sum : sum + item.stock;
      }, 0);
  
      // Valida que la suma no exceda datosArt.cantidad_recibida
      if (
        currentTotal + stockValue > transferRow.cantidad_enviada ||
        currentTotal + stockValue < transferRow.cantidad_enviada
      ) {
        setErrorCantidad(true);
      } else {
        setErrorCantidad(false);
      }
  
      // Actualiza el estado
      setStockPorTalles((prevStock) =>
        prevStock.map((item) =>
          item.id === id ? { ...item, stock: stockValue } : item
        )
      );
    };
  
    useEffect(() => {
      if (transferRow?.tiene_talles === 1 && transferRow.cantidad_enviada > 0) {
        const totalAsignado = stockPorTalles.reduce(
          (sum, item) => sum + item.stock,
          0
        );
  
        // Valida que la suma no exceda datosArt.cantidad_recibida
        if (totalAsignado > transferRow.cantidad_enviada || totalAsignado < transferRow.cantidad_enviada) {
          setErrorCantidad(true);
        } else {
          setErrorCantidad(false);
        }
      }
    }, [stockPorTalles, transferRow.cantidad_enviada]);
  
    useEffect(() => {
      if (transferRow) {
        if (transferRow.tiene_talles === 1) {
          getData(
            `/stock_prendas/detalle/${transferRow.almacen_origen}/${transferRow.id_articulo}`,
            setInventarioPrendas
          );
        }
      }
    }, [transferRow]);
  
    // console.log("stock", inventarioPrendas);

  return (
    <>
      <Dialog
        open={abrirDialogTrEnvi}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={transferRow?.tiene_talles === 1?"md":"sm"}
      >
        <DialogTitle id="alert-dialog-title" alignSelf="center">
          {"Confirmar Cancelación"}
        </DialogTitle>
        <DialogContent>
          <Container >
            <form onSubmit={guardarConfirmacionCancelacion}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={
                    transferRow?.tiene_talles === 1
                      ? // cantidadRec !== null &&
                        // cantidadRec > 0
                        9
                      : 12
                  }
                >
                  <Grid container  mb={1} spacing={1}>
              <dl style={{ fontSize: "20px", alignItems: "initial" }}>
                <dt>
                  <b>N° Transferencia: </b>
                  {transferRow.id_transaccion}
                </dt>
                <dt>
                  <b>Almacen de Origen: </b>
                  {transferRow.nombre_origen}
                </dt>
                <dt>
                  <b>Sucursal Destino: </b>
                  {transferRow.nombre}
                </dt>
                <dt>
                  <b>Articulo: </b>
                  {transferRow.nombre_articulo}
                </dt>
                <dt>
                  <b>Cantidad: </b>
                  {transferRow.cantidad_enviada}
                </dt>
              </dl>
              
              </Grid>
              </Grid>
                <Grid item xs={3}  mb={1} spacing={1}>
                  {transferRow?.tiene_talles === 1 && (
                    // cantidadRec !== null &&
                    // cantidadRec > 0 &&
                    <Box
                      border={1}
                      borderColor={grey[400]}
                      borderRadius={2}
                      p={1}
                      backgroundColor="#FFFFFF"
                    >
                      <Typography
                        variant="h6"
                        align="center"
                        // gutterBottom
                      >
                        Stock Por Talles
                      </Typography>
                      <Box textAlign="center">
                        <Typography variant="body1">
                          Total asignado:{" "}
                          {stockPorTalles.reduce(
                            (sum, item) => sum + item.stock,
                            0
                          )}{" "}
                          / {transferRow.cantidad_enviada}
                        </Typography>
                      </Box>
                      <Box
                        // border={1}
                        // borderColor={grey[300]}
                        borderRadius={2}
                        p={1}
                        backgroundColor="#FFFFFF"
                        maxHeight="80px"
                        overflow="auto"
                      >
                        <Grid container spacing={1}>
                          {talles.map((talle) => (
                            <Grid item xs={12} key={talle.id}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                // p={1}
                                border={1}
                                borderColor={grey[300]}
                                borderRadius={2}
                                // backgroundColor="#F9FAFB"
                              >
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                  display={"flex"}
                                  alignItems={"center"}
                                >
                                  {talle.talle}
                                </Typography>
                                <TextField
                                  type="number"
                                  variant="outlined"
                                  size="small"
                                  value={
                                    stockPorTalles.find(
                                      (item) => item.id === talle.id
                                    )?.stock || 0
                                  }
                                  onChange={(e) =>
                                    handleStockChange(talle.id, e.target.value)
                                  }
                                  InputProps={{
                                    inputProps: { min: 0 },
                                  }}
                                  sx={{
                                    maxWidth: "100px",
                                    borderColor: errorCantidad
                                      ? "red"
                                      : "inherit", // Borde rojo en caso de error
                                    "& .MuiOutlinedInput-root": {
                                      "&.Mui-focused fieldset": {
                                        borderColor: errorCantidad ? "red" : "", // Borde rojo cuando esté enfocado y haya error
                                      },
                                    },
                                  }}
                                />
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Grid container>
              <p style={{
                fontSize: "20px", 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                width: "100%"
              }}>
                ¿Desea cancelar la transferencia?
              </p>
              </Grid>
              <Stack direction="row">
                <Grid container direction={{ xs: "column", sm: "row" }}>
                  <Grid item xs={9}>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                    >
                      No
                    </Button>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                      disabled={errorCantidad}
                    >
                      Si
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </form>
          </Container>
        </DialogContent>
      </Dialog>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Dialog_cancelar_envio;
